<template>
    <div class="report__builder_schedule">
        <div class="report__builder_schedule_header">
            <view-actions
                :title="`${reportSchedulePeriodTypeDefault ? 'Edit' : 'Setup'} schedule of: ${reportName}`"
                :cancel-notify-active="false"
                :submit-button-active="false"
                @emit-notify-cancel-submit="reportStopEdit"
            />
        </div>
        <div class="report__builder_schedule_main">
            <div class="container">
                <div class="columns is-variable">
                    <div class="column">
                        <report-builder-schedule-form></report-builder-schedule-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import ReportBuilderScheduleForm from '@/components/ebs/reports/builder/schedule/ReportBuilderScheduleForm'

export default {
  name: 'report-builder-schedule',
  components: { ReportBuilderScheduleForm, ViewActions },
  computed: {
    reportName () {
      return this.$store.getters.getEbsReportBuilderName
    },
    reportSchedulePeriodTypeDefault () {
      return this.$store.getters.getEbsReportBuilderScheduleIntervalPeriodTypeDefault
    }
  },
  methods: {
    allowRedirectBeforeRouteLeave () {
      this.$eventBus.$emit('report-submit')
    },
    //
    reportStopEdit () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'ebs-report-list' })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/_reportbuilderschedule.scss";
</style>
